import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormSelect, useZionFormContext } from '@fs/zion-form'
import { Skeleton } from '@fs/zion-ui'
import { useStates } from '../../hooks'
import { NAME as zipName } from './ZipCodeField'
import { NAME as cityName } from './CityField'

export const NAME = 'province'

export const StateField = ({ disabled, value }) => {
  const [t] = useTranslation()
  const { states, loading } = useStates()

  const options = useMemo(() => states.map(({ display: { name } }) => ({ label: name, value: name })), [states])

  const { setValue } = useZionFormContext()

  useEffect(() => {
    if (value && states) setValue(NAME, value)
  }, [setValue, states, value])

  const onChange = (e) => {
    if (e.target.value !== 'Utah') {
      setValue(zipName, '')
      setValue(cityName, '')
    }
  }
  if (loading) {
    return <Skeleton.TextInput />
  }

  return (
    <FormSelect
      name={NAME}
      label={`${t('form.field.state.label', 'State')} *`}
      onChange={onChange}
      options={options}
      disabled={disabled}
      required
    />
  )
}
